import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer>
      <div class="footer-content">
        <nav class="footer-nav">
          @if (!isMaintenancePage()) {
            <a routerLink="/contact" class="footer-link">Kontakt</a>
            <span class="footer-divider">|</span>
          }
          <a routerLink="/imprint" class="footer-link">Impressum</a>
          <span class="footer-divider">|</span>
          <a routerLink="/terms" class="footer-link">AGB</a>
          <span class="footer-divider">|</span>
          <a routerLink="/privacy" class="footer-link">Datenschutzerklärung</a>
        </nav>
        <p class="footer-copyright">&copy; {{ copyrightYear$ | async }} {{ companyName$ | async }} Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }

    footer {
      background-color: #f9fafb;
      border-top: 1px solid #e5e7eb;
      padding: 2rem 1rem;
      margin-top: 3rem;
    }

    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    .footer-nav {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
    }

    .footer-link {
      color: oklch(51% 0.28 263.83);
      text-decoration: none;
      font-weight: 500;
      transition: opacity 0.2s ease;
    }

    .footer-link:hover {
      opacity: 0.7;
      text-decoration: underline;
    }

    .footer-link:focus {
      outline: 2px solid oklch(51% 0.28 263.83);
      outline-offset: 2px;
      border-radius: 2px;
    }

    .footer-divider {
      color: #d1d5db;
    }

    .footer-copyright {
      margin: 0;
      color: #6b7280;
      font-size: 0.875rem;
    }

    @media (max-width: 640px) {
      footer {
        padding: 1.5rem 0.5rem;
        margin-top: 2rem;
      }

      .footer-content {
        gap: 0.75rem;
      }

      .footer-nav {
        gap: 0.75rem;
      }

      .footer-link {
        font-size: 0.875rem;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  private configService = inject(ConfigService);
  private router = inject(Router);

  isMaintenancePage = computed(() => this.router.url === '/maintenance');

  copyrightYear$ = this.configService.getConfig('Company:CopyrightYear').pipe(
    map(year => year || new Date().getFullYear().toString())
  );

  companyName$ = this.configService.getConfig('Company:Name').pipe(
    map(name => name || 'ProTyco')
  );
}
